import { PULSE_VIEW_ID, trackPulseView } from './pulseViewIds';

/** Matches ChoseItemModalContent `isBasicSelectionOnce` — step 1 item grid vs modifier steps. */
export function isKidsComboModifierStep(
  itemStack: { length: number } | null | undefined,
  modifierGroup: Record<string, unknown> | null | undefined
): boolean {
  return Boolean(itemStack?.length && Object.keys(modifierGroup ?? {}).length);
}

/** Edit flow hydrates stack on the next render; defer Pulse until then. */
export function isKidsComboEditHydrating(params: {
  isCustomize: boolean;
  itemStackLength: number;
}): boolean {
  return params.isCustomize && params.itemStackLength === 0;
}

let menuViewTracked = false;
let customizationViewTracked = false;

export function resetKidsComboPulseViewSession(): void {
  menuViewTracked = false;
  customizationViewTracked = false;
}

function trackKidsComboMenuOnce(pagePath?: string): void {
  if (menuViewTracked) return;
  menuViewTracked = true;
  trackPulseView(PULSE_VIEW_ID.KIDSCOMBO_MENU, {
    page_path: pagePath ?? window.location.pathname,
  });
}

function trackKidsComboCustomizationModalOnce(pagePath?: string): void {
  if (customizationViewTracked) return;
  customizationViewTracked = true;
  trackPulseView(PULSE_VIEW_ID.CUSTOMIZATION_MODAL, {
    page_path: pagePath ?? window.location.pathname,
  });
}

/**
 * Fire kidscombo_menu on step 1, customization_modal on step 2+.
 * Each fires at most once per picker-modal session.
 */
export function syncKidsComboPulseViewForStep(params: {
  isStepOne: boolean;
  pagePath?: string;
}): void {
  if (params.isStepOne) {
    trackKidsComboMenuOnce(params.pagePath);
    return;
  }
  trackKidsComboCustomizationModalOnce(params.pagePath);
}
